import { useAuthStore } from '../../stores/authStore'
import { 
  BarChart3, 
  Gavel, 
  Settings, 
  ArrowRight,
  Monitor,
  Smartphone
} from 'lucide-react'

const systems = [
  {
    id: 'gestao',
    name: 'Sistema de Gestão',
    description: 'Gestão completa de leilões, clientes e organizadores',
    icon: BarChart3,
    color: 'bg-rematei-blue',
    url: '/dashboard',
    features: ['Cadastros', 'Relatórios', 'Financeiro', 'Configurações']
  },
  {
    id: 'painel',
    name: 'Painel de Lances',
    description: 'Controle de lances em tempo real',
    icon: Gavel,
    color: 'bg-rematei-green',
    url: 'http://localhost:8000/painel_lances',
    features: ['Lances ao vivo', 'Placares', 'vMix/OBS', 'Tempo real']
  }
]

export default function SystemSelector() {
  const { user, logout } = useAuthStore()

  const handleSystemSelect = (system) => {
    if (system.url.startsWith('http')) {
      // Redirecionamento externo (Flask)
      window.location.href = system.url
    } else {
      // Redirecionamento interno (React)
      window.location.href = system.url
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-4xl">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-rematei-blue rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-2xl">R</span>
              </div>
              <span className="ml-3 text-3xl font-bold text-gray-900">rematei</span>
            </div>
          </div>
          
          <h1 className="text-3xl font-extrabold text-gray-900">
            Bem-vindo, {user?.full_name}!
          </h1>
          <p className="mt-2 text-lg text-gray-600">
            Escolha o sistema que deseja acessar
          </p>
        </div>

        {/* Systems Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {systems.map((system) => {
            const Icon = system.icon
            return (
              <div
                key={system.id}
                className="card-rematei hover:shadow-lg transition-shadow cursor-pointer group"
                onClick={() => handleSystemSelect(system)}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className={`p-3 rounded-lg ${system.color}`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-rematei-blue transition-colors" />
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {system.name}
                </h3>
                
                <p className="text-gray-600 mb-4">
                  {system.description}
                </p>
                
                <div className="space-y-2">
                  {system.features.map((feature, index) => (
                    <div key={index} className="flex items-center text-sm text-gray-500">
                      <div className="w-1.5 h-1.5 bg-rematei-blue rounded-full mr-2"></div>
                      {feature}
                    </div>
                  ))}
                </div>
                
                <div className="mt-6 pt-4 border-t border-gray-200">
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div className="flex items-center">
                      {system.id === 'gestao' ? (
                        <>
                          <Monitor className="w-4 h-4 mr-1" />
                          <Smartphone className="w-4 h-4 mr-2" />
                          PWA Responsivo
                        </>
                      ) : (
                        <>
                          <Monitor className="w-4 h-4 mr-2" />
                          Desktop
                        </>
                      )}
                    </div>
                    <span className="font-medium text-rematei-blue">
                      Acessar →
                    </span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        {/* User Info & Logout */}
        <div className="mt-8 text-center">
          <div className="inline-flex items-center space-x-4 text-sm text-gray-500">
            <span>Logado como: {user?.email}</span>
            <span>•</span>
            <button
              onClick={logout}
              className="text-rematei-blue hover:text-rematei-blue-dark font-medium"
            >
              Sair
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}